﻿
import {ComplaintComment } from '../administration/complaint-configuration/complaint-comment';
import { ComplaintAnswerFile } from '../administration/complaint-configuration/complaint-answer-file';
export class ComplaintDetail {
    id: number;
    title: string;
    description: string;
    categoryId: number;
    dateCreated: Date;
    statusId: number;
    active: boolean;
    comment: string;
    userId: number;
    userName: string;
    visible: boolean;
    municipaltyId: number;
    municipalityName: string;
    pictureUrl: string;
    answerUserId: number;
    complaintAnswerUserName: string;
    organizationId: number;
    organizationName: string;
    complaintComment: any[];
    gpsx: number;
    gpsy: number;
    locationDescription: string;
    complaintAnswer: string;
    complaintAnswerFile: ComplaintAnswerFile[];
    lastUpdateDate: Date;

    constructor() {
        this.complaintComment = [];
    }
}